/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ng2-bootstrap/alert/alert.component';
import * as i3 from 'ng2-bootstrap/alert/alert.config';
const styles_AlertComponent:any[] = ([] as any[]);
export const RenderType_AlertComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AlertComponent,data:{}});
function View_AlertComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),7,'button',[['aria-label','Close'],['class','close'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.close()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['×'])),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','sr-only']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['Close'])),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵted((null as any),['\n    ']))],(null as any),(null as any));
}
function View_AlertComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),7,'div',[['role','alert']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AlertComponent_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),i0.ɵncd((null as any),
          0),(_l()(),i0.ɵted((null as any),['\n  '])),(_l()(),i0.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = ('alert alert-' + _co.type);
    const currVal_1:any = _co.classes;
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_2:any = _co.dismissible;
    _ck(_v,5,0,currVal_2);
  },(null as any));
}
export function View_AlertComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_AlertComponent_1)),i0.ɵdid(16384,
      (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.AlertComponent = _v.component;
    const currVal_0:boolean = !_co.isClosed;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_AlertComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'alert',([] as any[]),
      (null as any),(null as any),(null as any),View_AlertComponent_0,RenderType_AlertComponent)),
      i0.ɵdid(114688,(null as any),0,i2.AlertComponent,[i3.AlertConfig],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AlertComponentNgFactory:i0.ComponentFactory<i2.AlertComponent> = i0.ɵccf('alert,ngx-alert',
    i2.AlertComponent,View_AlertComponent_Host_0,{type:'type',dismissible:'dismissible',
        dismissOnTimeout:'dismissOnTimeout'},{onClose:'onClose',onClosed:'onClosed'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL2FsZXJ0L2FsZXJ0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAvYWxlcnQvYWxlcnQuY29tcG9uZW50LmQudHMiLCJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAvYWxlcnQvYWxlcnQuY29tcG9uZW50LmQudHMuQWxlcnRDb21wb25lbnQuaHRtbCIsIm5nOi8vL2Q6L2EvMS9zL1NvZnR3YXJlTWFuYWdlci9ub2RlX21vZHVsZXMvbmcyLWJvb3RzdHJhcC9hbGVydC9hbGVydC5jb21wb25lbnQuZC50cy5BbGVydENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuPHRlbXBsYXRlIFtuZ0lmXT1cIiFpc0Nsb3NlZFwiPlxuICA8ZGl2IFtjbGFzc109XCInYWxlcnQgYWxlcnQtJyArIHR5cGVcIiByb2xlPVwiYWxlcnRcIiBbbmdDbGFzc109XCJjbGFzc2VzXCI+XG4gICAgPHRlbXBsYXRlIFtuZ0lmXT1cImRpc21pc3NpYmxlXCI+XG4gICAgICA8YnV0dG9uIHR5cGU9XCJidXR0b25cIiBjbGFzcz1cImNsb3NlXCIgYXJpYS1sYWJlbD1cIkNsb3NlXCIgKGNsaWNrKT1cImNsb3NlKClcIj5cbiAgICAgICAgPHNwYW4gYXJpYS1oaWRkZW49XCJ0cnVlXCI+JnRpbWVzOzwvc3Bhbj5cbiAgICAgICAgPHNwYW4gY2xhc3M9XCJzci1vbmx5XCI+Q2xvc2U8L3NwYW4+XG4gICAgICA8L2J1dHRvbj5cbiAgICA8L3RlbXBsYXRlPlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgPC9kaXY+XG48L3RlbXBsYXRlPlxuICAiLCI8YWxlcnQ+PC9hbGVydD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0dtQyw2Q0FDN0I7TUFBQTtVQUFBO1FBQUE7UUFBQTtRQUF1RDtVQUFBO1VBQUE7UUFBQTtRQUF2RDtNQUFBLGdDQUF5RTtNQUN2RTtVQUFBO01BQXlCLHNDQUFjO01BQ3ZDO1VBQUE7TUFBc0IsMENBQVk7TUFDM0I7OztvQkFOYyx5Q0FDM0I7TUFBQTtNQUFBLHFDQUFBO2tEQUFBO01BQUEsMkJBQXNFLDJDQUNwRTthQUFBO2FBQUE7VUFBQSx3QkFLVyxrREFDWDtVQUFBLEdBQXlCLHlDQUNyQjtVQUFBOztJQVJEO0lBQTZDO0lBQWxELFdBQUssVUFBNkMsU0FBbEQ7SUFDWTtJQUFWLFdBQVUsU0FBVjs7OztvQkFISix1Q0FDQTtNQUFBLDJFQUFBO01BQUE7TUFBQSxlQVVXOztJQVZEO0lBQVYsV0FBVSxTQUFWOzs7O29CQ0RBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./Client/$$_gendir/~/ng2-bootstrap/alert/alert.component.ngfactory.ts